/**
 * @desc WFS库存实时分页查询
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.platDataFlow.reportPage.wfsRealTimeInventoryPage.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/reportPage/wfsRealTimeInventoryPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
